import './style.scss';

export function common_symptoms_block() {
    const block = document.querySelector('.common_symptoms_block');
    if (!block) return;
}

